"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _index = _interopRequireDefault(require("./sagas/index"));

var _index2 = _interopRequireDefault(require("./reducers/index"));

var _TranslationContext = require("./context/TranslationContext");

var _App = _interopRequireDefault(require("./components/App"));

var _PropsContext = require("./context/PropsContext");

var _Actions = require("./actions/Actions");

var _ConfigSelectors = require("./selectors/ConfigSelectors/ConfigSelectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Widget = function Widget(_ref) {
  var _config$balanceListen2;

  var i18n = _ref.i18n,
      language = _ref.language,
      __instanceId = _ref.__instanceId,
      __pageId = _ref.__pageId;
  var t = i18n ? function (key, options) {
    var tr = i18n(key, options);
    return tr || key;
  } : function (key) {
    return key;
  };
  if (!language) return null;
  var dispatch = (0, _reactRedux.useDispatch)();
  var config = (0, _reactRedux.useSelector)(_ConfigSelectors.configSelector);
  (0, _react.useEffect)(function () {
    dispatch((0, _Actions.setInstanceId)(__instanceId));
  }, []);
  (0, _react.useEffect)(function () {
    var _config$balanceListen;

    if (config && config !== null && config !== void 0 && (_config$balanceListen = config.balanceListenerActions) !== null && _config$balanceListen !== void 0 && _config$balanceListen.length) dispatch((0, _Actions.setBalanceListenerActionName)(config === null || config === void 0 ? void 0 : config.balanceListenerActions));
  }, [config && (config === null || config === void 0 ? void 0 : (_config$balanceListen2 = config.balanceListenerActions) === null || _config$balanceListen2 === void 0 ? void 0 : _config$balanceListen2.length)]);
  return /*#__PURE__*/_react.default.createElement(_TranslationContext.TranslationProvider, {
    t: t
  }, /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId: __instanceId,
      __pageId: __pageId
    }
  }, /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    pageId: __pageId
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.language.language
  };
};

var ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
var exported = ConnectedWidget;
var _default = exported;
exports.default = _default;
Widget.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string
};
exported.reducer = _index2.default;
exported.sagas = _index.default; // exported.middlewares = [logger];